import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getByID } from "../../api/API";
import "../../styles/MemberProfile.css";
import LoadingSpinner from "../Generic/LoadingSpinner";

const MemberProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);

  // check login
  const token = localStorage.getItem("membersToken");

  useEffect(() => {
    const fetchMember = async () => {
      try {
        if (!token) {
          setLoading(false);
          return;
        }

        const data = await getByID("members", id, { depth: 2 });
        setMember(data);
      } catch (err) {
        console.error("Error fetching member:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchMember();
  }, [id, token]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center my-5">
        <LoadingSpinner size="4rem" message="Fetching member profile..." />
      </div>
    );
  }
  // Not logged in
  if (!token) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="card shadow p-4 text-center rounded-4 login-card">
          <h2 className="mb-3">Login Required</h2>
          <p className="text-muted">
            Please login to see this member's full profile.
          </p>
          <button
            className="btn btn-primary rounded-pill mt-3 px-4"
            onClick={() => navigate("/login")}
          >
            Login
          </button>
        </div>
      </div>
    );
  }

  // Member not found
  if (!member) {
    return <p className="text-center my-5">Member not found</p>;
  }

  // Logged in — full profile
  return (
    <div className="container my-5">
      <div className="card shadow rounded-4 p-4 profile-card">
        <div className="d-flex align-items-center gap-3">
          {member.avatar?.url ? (
            <img
              src={member.avatar.url}
              alt={`${member.firstName} ${member.lastName}`}
              className="rounded-circle profile-avatar"
            />
          ) : (
            <div className="rounded-circle bg-secondary d-flex justify-content-center align-items-center profile-avatar text-white">
              {member.firstName?.[0]}
              {member.lastName?.[0]}
            </div>
          )}
          <div>
            <h2 className="mb-1">
              {member.firstName} {member.lastName}
            </h2>
            <p className="text-muted">
              {member.jobTitle || "Professional"}{" "}
              {member.companyName && `@ ${member.companyName}`}
            </p>
          </div>
        </div>
        <hr />
        <div className="row mt-3">
          <div className="col-md-6">
            <p>
              <strong>Email:</strong> {member.email}
            </p>
            <p>
              <strong>Phone:</strong> {member.phone || "N/A"}
            </p>
            <p>
              <strong>Location:</strong> {member.location || "N/A"}
            </p>
          </div>
          <div className="col-md-6">
            <p>
              <strong>Experience:</strong> {member.experience || 0} years
            </p>
            <p>
              <strong>LinkedIn:</strong> {member.linkedin || "N/A"}
            </p>
            <p>
              <strong>Website:</strong> {member.website || "N/A"}
            </p>
          </div>
        </div>
        <div className="mt-3">
          <p>
            <strong>Bio:</strong>
          </p>
          <p className="text-muted">{member.bio || "No bio available."}</p>
        </div>
      </div>
    </div>
  );
};

export default MemberProfile;
